<template>
    <div class="form-row form-row--profile-phone-number">
        <label class="form-label">Phone number:</label>

        <component 
            v-if="VueTelInput" 
            :is="VueTelInput" 
            type="text"
            class="field field-large"
            v-model="currentPhone"
            @validate="isValid"
            @input="onInput"
            :preferredCountries="is_admin ? ['bg'] : ['us', 'ca', 'au', 'fr']" 
            placeholder=""
        />
        <input type="hidden" name="phone_number" :value="currentPhone" />

        <div class="phone-number__meta">
            <template v-if="is_admin">
                <span v-if="testSms.result">{{ testSms.result }} |  </span>
                <a href="#" @click.prevent="sendTestSms" v-if="hasValidPhone && testSms.state === 'pending'">Send a test message</a>
                <span v-if="testSms.state === 'sending'">Sending ... </span>
            </template>
            
            <span class="phone-number__warning" v-if="edited && !hasValidPhone">Invalid Phone Number!</span>
        </div>


        <div class="cl">&nbsp;</div>
	</div>
</template>

<script>
import { markRaw } from "vue";

export default {
	name: 'profile-phone-number',
    props: [ 'phone', 'is_admin' ],
	data() {
		return {
            currentPhone: this.phone,
            hasValidPhone: !!this.phone,
            edited: false,
            testSms: {
                state: "pending",
                result: "",
            },
            VueTelInput: null
		};
	},

	methods: {
        onInput(event) {
            this.edited = true;
            this.currentPhone = event.target.value;
        },
        
        isValid(data) {
            this.hasValidPhone = data?.valid;
        },

        sendTestSms() {
            if ( !this.hasValidPhone ) {
                // should happen, but who knows
                return;
            }
            
            this.testSms.state = "sending";
            $.ajax({
                url: '/profile/send-test-sms-message',
                type: "POST",
                dataType: 'json',
                data: {
                    number: this.currentPhone
                },
                complete: () => {
                    this.testSms.state = "pending";
                },

                // I'm a little lazy here to check all possible errors :|
                success: resp => {
                    this.testSms.result = resp.success ? "Message has been sent!" : "Something went wrong!";
                },

                error: () => {
                    this.testSms.result = "Something went wrong!";
                },
            })
        },
        loadComponent() {
            Promise.all([
                import('vue-tel-input'),
                import('vue-tel-input/vue-tel-input.css'),
            ]).then(([{ VueTelInput }]) => this.VueTelInput = markRaw(VueTelInput));
        },
	},
    created() {
        this.loadComponent();
    },
};
</script>

<style>
	.form-row--profile-phone-number .dropdown { padding: 0px; }
	.phone-number__warning { color: var(--color-red-600); }
	.phone-number__meta { float: left; line-height: 2; }
	
	.form-row--profile-phone-number .field { 
		border-radius: var(--border-radius-1);
		border: 1px solid var(--color-gray-300);
		background-color: var(--color-white);
	}

	.form-row--profile-phone-number .field:focus-within {
		border-color: var(--color-gray-500);
		box-shadow: none;
	}

	.form-row--profile-phone-number .field input{
		background: none;
	}
</style>